export enum LabelFontStyle {
    REGULAR = "REGULAR",
    BOLD = "BOLD",
    ITALIC = "ITALIC",
    BOLD_ITALIC = "BOLD_ITALIC"
}
